import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  html {
    font-size: clamp(16px, 0.5vw + 14px, 20px);
  }

  body {
    margin: 0;
    font-family: ${({ theme }) => theme.fontFamily};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.foreground};
  }

  * {
    box-sizing: border-box;
  }

  .card-shadow {
    box-shadow: ${({ theme }) => theme.shadowCard};
  }

  .card-shadow-hover {
    box-shadow: ${({ theme }) => theme.shadowCardHover};
  }
`;

